/**
 * Безопасно вызывает переданную функцию, перехватывая и логируя ошибки.
 * Поддерживает как синхронные, так и асинхронные функции.
 */
export const safelyInvoke = <TArgs extends unknown[]>(
  callback: ((...args: TArgs) => void | Promise<void>) | undefined,
  ...args: TArgs
): void => {
  if (!callback) {
    return;
  }

  try {
    Promise.resolve(callback(...args)).catch(console.error);
  } catch (error) {
    console.error(error);
  }
};
